(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    let activeClose;
    let dialogSequence = 0;

    const openSizeChart = (trigger) => {
      const template = trigger.closest('[data-size-chart-control]')?.querySelector('[data-size-chart-template]');
      if (!template || !template.content.querySelector('img')) return;

      activeClose?.();
      const picker = trigger.closest('variant-picker');
      const pickerIdentity = picker
        ? ['sectionId', 'blockId', 'productId'].map((key) => [key, picker.dataset[key]])
        : null;
      const previousScrollLock = document.documentElement.getAttribute('scroll-lock');
      const dialog = document.createElement('dialog');
      dialog.className = 'size-chart-dialog';
      dialog.append(template.content.cloneNode(true));
      dialog.querySelectorAll('img').forEach((image) => {
        image.setAttribute('loading', 'eager');
      });
      const title = dialog.querySelector('[data-size-chart-title]');
      title.id = `size-chart-dialog-title-${++dialogSequence}`;
      dialog.setAttribute('aria-labelledby', title.id);

      let cleanedUp = false;
      const cleanup = () => {
        if (cleanedUp) return;
        cleanedUp = true;
        dialog.remove();
        if (activeClose === closeSizeChart) activeClose = undefined;
        if (previousScrollLock === null) document.documentElement.removeAttribute('scroll-lock');
        else document.documentElement.setAttribute('scroll-lock', previousScrollLock);

        let focusTarget = trigger;
        if (!focusTarget.isConnected && pickerIdentity) {
          const replacement = [...document.querySelectorAll('variant-picker')].find((candidate) =>
            pickerIdentity.every(([key, value]) => candidate.dataset[key] === value)
          );
          focusTarget = replacement?.querySelector('[data-size-chart-trigger]');
        }
        focusTarget?.focus({ preventScroll: true });
      };

      const closeSizeChart = () => {
        if (dialog.open) dialog.close();
        cleanup();
      };

      dialog.addEventListener('close', cleanup, { once: true });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeSizeChart();
      });
      dialog.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest('[data-size-chart-close]')) {
          closeSizeChart();
          return;
        }

        const zoomButton = target.closest('[data-size-chart-zoom]');
        if (zoomButton) {
          const zoomed = zoomButton.getAttribute('aria-pressed') !== 'true';
          const image = zoomButton.querySelector('img');
          const imageScroll = zoomButton.closest('.size-chart-dialog__image-scroll');
          const zoomWidth = Math.max(image.naturalWidth, imageScroll.clientWidth * 2, 1200);
          const label = zoomed ? zoomButton.dataset.zoomOut : zoomButton.dataset.zoomIn;
          if (!image.dataset.originalSizes) image.dataset.originalSizes = image.sizes;
          zoomButton.style.setProperty('--size-chart-zoom-width', `${zoomWidth}px`);
          zoomButton.setAttribute('aria-pressed', String(zoomed));
          zoomButton.setAttribute('aria-label', label);
          zoomButton.querySelector('[data-size-chart-zoom-label]').textContent = label;
          image.sizes = zoomed ? `${zoomWidth}px` : image.dataset.originalSizes;
          if (!zoomed) imageScroll.scrollLeft = 0;
          return;
        }

        if (target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            closeSizeChart();
          }
        }
      });

      document.body.append(dialog);
      activeClose = closeSizeChart;
      document.documentElement.setAttribute('scroll-lock', '');
      dialog.showModal();
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-size-chart-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openSizeChart(trigger);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
